<template>
  <div class="pager">
    <div class="pager-buttons">
      <button class="button is-small" :disabled="isLoading || currentPage === 1" @click="pageDown">
        <i class="icon-angle-left" aria-hidden="true" />
      </button>
      <button class="button is-small" :disabled="isLoading || currentPage >= lastPageNumber + 1" @click="pageUp">
        <i class="icon-angle-right" aria-hidden="true" />
      </button>
    </div>
    <div class="paper-per-number">
      {{ currentPageAndMaxLength }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalNumber: {
      type: Number,
      required: true,
    },
    numberOfItemPerPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    pageUp: {
      type: Function,
    },
    // eslint-disable-next-line vue/require-default-prop
    pageDown: {
      type: Function,
    },
    isLoading: {
      type: Boolean,
    },
  },
  computed: {
    lastPageNumber() {
      return Math.floor(this.totalNumber / this.numberOfItemPerPage);
    },
    currentPageAndMaxLength() {
      const startNumber = this.numberOfItemPerPage * (this.currentPage - 1) + 1;
      const endNumber = this.numberOfItemPerPage * this.currentPage;
      return `${startNumber} - ${endNumber > this.totalNumber ? this.totalNumber : endNumber} of ${this.totalNumber}`;
    },
  },
};
</script>

<style scoped lang="scss">
.pager {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  height: 68px;
  border: solid 1px $gray-300;
  border-top: 0;
  background-color: white;

  .pager-buttons {
    margin: 0 20px;

    .button {
      margin-right: 2px;
      border: 0;
    }
  }
}
</style>
